svg4everybody();

(function() {
    $('.js-trigger').on('click', function () {
        var _trigger = $(this);
        var _results = $(this).siblings('.js-results');
        _trigger.parent().toggleClass('open');
        _results.stop().slideToggle();
        $('.js-trigger').not(_trigger).parent().removeClass('open');
        $('.js-results').not(_results).slideUp();
        return false;
    });
    
    /* outside click close results */

    $(document).on('click', function (e) {
        var $trigger = $('.js-trigger');
        if ($trigger !== e.target && !$trigger.has(e.target).length) {
            $('.js-trigger').parent().removeClass('open');
            $('.js-results').slideUp();
        }
    });

    $('.js-datepicker').datepicker({
        language: 'ka'
    });

})();